// src/pages/MyOrders.jsx — Epic Games Store style
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import { getUserOrders } from "../services/orderService";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguagesContext";

const STATUS = {
  delivered: { label:"Delivered",  color:"#22c55e", bg:"rgba(34,197,94,0.1)",   border:"rgba(34,197,94,0.25)",   icon:"✅" },
  paid:      { label:"Processing", color:"#eab308", bg:"rgba(234,179,8,0.1)",   border:"rgba(234,179,8,0.25)",   icon:"⏳" },
  pending:   { label:"Pending",    color:"#0078F2", bg:"rgba(0,120,242,0.1)",   border:"rgba(0,120,242,0.25)",   icon:"🕐" },
  expired:   { label:"Expired",    color:"#6b6b6b", bg:"rgba(255,255,255,0.04)",border:"rgba(255,255,255,0.08)", icon:"⏰" },
  failed:    { label:"Failed",     color:"#ef4444", bg:"rgba(239,68,68,0.08)",  border:"rgba(239,68,68,0.18)",   icon:"❌" },
};
const ACC_COLORS = { steam:"#1b9aff", epic:"#e0e0e0", game_account:"#a78bfa", shared:"#34d399", private:"#fbbf24", family:"#f97316" };
const ACC_ICONS  = { steam:"🎮",      epic:"⬛",       game_account:"👤",       shared:"🔗",     private:"🔒",     family:"👨‍👩‍👧" };

const S = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
*, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
.op { min-height:100vh; background:#121212; color:#fff; font-family:'Inter',sans-serif; }
.op-hdr { padding:100px 80px 40px; border-bottom:1px solid rgba(255,255,255,0.06); background:linear-gradient(180deg,rgba(0,120,242,0.04) 0%,transparent 100%); }
.op-hdr-inner { max-width:1200px; margin:0 auto; }
.op-title { font-size:36px; font-weight:800; color:#fff; letter-spacing:-1px; margin-bottom:6px; }
.op-title span { color:#0078F2; }
.op-sub { font-size:14px; color:#6b6b6b; }
.op-body { max-width:1200px; margin:0 auto; padding:28px 80px 80px; }
.filter-row { display:flex; gap:6px; margin-bottom:28px; flex-wrap:wrap; }
.f-tab { font-family:'Inter',sans-serif; font-size:13px; font-weight:600; color:#6b6b6b; background:none; border:1px solid rgba(255,255,255,0.08); border-radius:4px; padding:7px 16px; cursor:pointer; transition:all 0.15s; }
.f-tab:hover { color:#fff; border-color:rgba(255,255,255,0.2); }
.f-tab.active { color:#fff; background:#0078F2; border-color:#0078F2; }
.o-card { background:#1a1a1a; border:1px solid rgba(255,255,255,0.07); border-radius:10px; overflow:hidden; margin-bottom:12px; transition:border-color 0.15s; }
.o-card:hover { border-color:rgba(255,255,255,0.14); }
.o-card-top { padding:20px 24px; display:flex; align-items:center; gap:16px; flex-wrap:wrap; }
.o-cover { width:60px; height:44px; border-radius:6px; overflow:hidden; background:#2a2a2a; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
.o-cover img { width:100%; height:100%; object-fit:cover; }
.o-info { flex:1; min-width:0; }
.o-game { font-size:16px; font-weight:700; color:#fff; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-bottom:4px; }
.o-meta { font-size:12px; color:#6b6b6b; display:flex; gap:8px; align-items:center; flex-wrap:wrap; }
.o-acc-pill { display:inline-flex; align-items:center; gap:4px; font-size:11px; font-weight:600; padding:2px 8px; border-radius:4px; }
.o-status { padding:5px 12px; border-radius:4px; font-size:12px; font-weight:700; white-space:nowrap; }
.o-amount { font-size:20px; font-weight:800; color:#fff; }
.o-card-bot { padding:0 24px 16px; border-top:1px solid rgba(255,255,255,0.05); padding-top:14px; display:flex; gap:8px; flex-wrap:wrap; }
.o-action { font-family:'Inter',sans-serif; font-size:13px; font-weight:600; padding:8px 16px; border-radius:4px; text-decoration:none; cursor:pointer; transition:all 0.15s; }
.oa-primary { background:#0078F2; color:#fff; border:none; }
.oa-primary:hover { background:#0a84ff; }
.oa-secondary { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); color:#a3a3a3; }
.oa-secondary:hover { border-color:rgba(255,255,255,0.2); color:#fff; }
.empty { text-align:center; padding:80px 20px; }
.empty-ico { font-size:56px; margin-bottom:16px; }
.empty-t { font-size:22px; font-weight:700; color:#4a4a4a; margin-bottom:8px; }
.empty-d { font-size:14px; color:#3a3a3a; margin-bottom:24px; }
.empty-btn { display:inline-block; background:#0078F2; color:#fff; font-family:'Inter',sans-serif; font-size:14px; font-weight:700; padding:13px 28px; border-radius:6px; text-decoration:none; transition:all 0.15s; }
.empty-btn:hover { background:#0a84ff; transform:translateY(-1px); }
.skel { background:#1a1a1a; border-radius:10px; animation:shim 1.5s ease infinite; }
@keyframes shim { 0%,100%{opacity:.5} 50%{opacity:.8} }
@media(max-width:1100px){ .op-hdr,.op-body { padding-left:40px; padding-right:40px; } }
@media(max-width:680px){ .op-hdr,.op-body { padding-left:20px; padding-right:20px; } .o-amount { font-size:16px; } }
`;

export default function MyOrders() {
  const { user } = useAuth();
  const { t } = useLang();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    if (!user) return;
    getUserOrders(user.uid).then(o => { setOrders(o); setLoading(false); }).catch(() => setLoading(false));
  }, [user]);

  const filtered = filter === "all" ? orders : orders.filter(o => o.status === filter);

  function fmtDate(ts) {
    if (!ts) return "—";
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-US", { day:"numeric", month:"short", year:"numeric" });
  }

  const FILTERS = [
    { k:"all",       l:`${t("orders_all")} (${orders.length})` },
    { k:"delivered", l:t("orders_delivered") },
    { k:"pending",   l:t("orders_pending") },
    { k:"expired",   l:t("orders_expired") },
  ];

  return (
    <>
      <style>{S}</style>
      <div className="op">
        <Navbar />
        <div className="op-hdr">
          <div className="op-hdr-inner">
            <h1 className="op-title">My <span>{t("orders_title")}</span></h1>
            <p className="op-sub">{orders.length} total orders</p>
          </div>
        </div>
        <div className="op-body">
          <div className="filter-row">
            {FILTERS.map(f => <button key={f.k} className={`f-tab ${filter===f.k?"active":""}`} onClick={() => setFilter(f.k)}>{f.l}</button>)}
          </div>
          {loading ? [...Array(3)].map((_,i) => <div key={i} className="skel" style={{ height:100, marginBottom:12 }} />)
          : filtered.length === 0 ? (
            <div className="empty">
              <div className="empty-ico">{filter==="all"?"🎮":"🔍"}</div>
              <div className="empty-t">{filter==="all" ? t("no_orders") : `No ${filter} orders`}</div>
              <div className="empty-d">{filter==="all" ? t("no_orders_sub") : "Try a different filter."}</div>
              {filter==="all" && <Link to="/store" className="empty-btn">Browse Games →</Link>}
            </div>
          ) : filtered.map(order => {
            const cfg = STATUS[order.status] || STATUS.pending;
            const ac = ACC_COLORS[order.accountType] || "#a3a3a3";
            const ai = ACC_ICONS[order.accountType] || "🎮";
            return (
              <div key={order.id} className="o-card">
                <div className="o-card-top">
                  <div className="o-cover">{order.gameCoverImage ? <img src={order.gameCoverImage} alt={order.gameTitle} /> : "🎮"}</div>
                  <div className="o-info">
                    <div className="o-game">{order.gameTitle}</div>
                    <div className="o-meta">
                      <span>#{order.id?.slice(0,10)}</span>
                      <span>·</span>
                      <span>{fmtDate(order.createdAt)}</span>
                      {order.accountType && <span className="o-acc-pill" style={{ background:`${ac}14`, border:`1px solid ${ac}28`, color:ac }}>{ai} {order.accountType}</span>}
                    </div>
                  </div>
                  <div className="o-status" style={{ background:cfg.bg, border:`1px solid ${cfg.border}`, color:cfg.color }}>{cfg.icon} {cfg.label}</div>
                  <div className="o-amount">${order.amount?.toFixed(2)}</div>
                </div>
                <div className="o-card-bot">
                  {order.status==="delivered" && <Link to={`/order-success/${order.id}`} className="o-action oa-primary">{t("view_creds")}</Link>}
                  {order.status==="pending"   && <Link to={`/checkout/${order.gameId}`}  className="o-action oa-primary">{t("complete_pay")}</Link>}
                  {order.status==="delivered" && <Link to={`/orders/${order.id}/chat`}   className="o-action oa-secondary">{t("support_chat_btn")}</Link>}
                  <Link to={`/game/${order.gameId}`} className="o-action oa-secondary">{t("view_game")}</Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
  
    </>
  );
}